export default () => {
    let button = $('.carrier-job-offers-content-body-box-header');

    toggleItem(button.first());

    button.click(function() {
        toggleItem($(this));
    });
}

let toggleItem = (button) => {
    let content = button.siblings('.carrier-job-offers-content-body-box-description');
    content.slideToggle();
    button.toggleClass('active');

    let active = $('.carrier-job-offers-content-body-box-header.active').not(button);
    active.removeClass('active');
    active.siblings('.carrier-job-offers-content-body-box-description').slideUp();
};
